import { Suspense } from 'react';
import { lazy } from 'utils/generic/lazy';

const { ProvidersTrackerComponent } = lazy(
  () => import(/* webpackChunkName: "providers-tracker" */ './component')
);

export const ProvidersTracker = () => {
  if (!window.__dataspot__) {
    return null;
  }

  return (
    <Suspense>
      <ProvidersTrackerComponent />
    </Suspense>
  );
};
